var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBtn)?_c('button',{staticClass:"btn btn-fill btn-icon btn-success",attrs:{"title":"Imprimir documentação de cadastro do ticket."},on:{"click":function($event){return _vm.handleDocumentsPrint()}}},[_c('i',{staticClass:"ti-envelope"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-217a90f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Tickets/Actions/BtnOpenTicketRegisterDocPrint.vue
// module id = RcaJ
// module chunks = 10